// @flow
import React from 'react';
import { Link } from 'react-router';
import nest from 'recompose/nest';
import { useSelector, shallowEqual } from 'react-redux';

import {
  Catalog,
  Options,
  CardNumberBadge,
} from 'app/common/components/Shop';

import Sticky, { withStickyRows } from 'app/common/components/Sticky';
// import { componentFromMapParams } from 'app/common/containers/componentFromMap';
import { WithRouterParamsProviderV3, withRouterParamsE } from 'app/common/context/WithRouterParams';
import PlainNav, { NavItem } from 'app/common/ui/PlainNav';
import CommonPageTemplate, { withDealerTitle } from 'app/common/pages/CommonPageTemplate';

import CartPage from './SectionPages/CartPage';
import PaymentPage from './SectionPages/PaymentPage';
import OrderHistoryPage from './SectionPages/OrderHistoryPage';
import styles from './ShopPage.scss';


const menu = [
  ['catalog', 'Каталог'],
  ['cart', 'Корзина'],
  ['history', 'Мои заказы'],
  ['options', 'Настройки'],
];

const PageTemplate = withDealerTitle('Магазин')(
  nest(WithRouterParamsProviderV3, CommonPageTemplate)
);

const withParams = withRouterParamsE([
  'productSlug',
  'category',
  'product',
  'step',
]);

const Menu = withStickyRows(({ children, router }) => {
  const shopEnabled = useSelector(state => state.user.shop.enabled, shallowEqual);
  if (!shopEnabled) {
    router.replace('/');
  }
  return (
    <React.Fragment>
      <Sticky
        number={1}
        className={styles.opaque}
      >
        <PlainNav className={styles.menu}>
          {menu.map(([key, title]) => ( // eslint-disable-line no-unused-vars
            <NavItem className={styles.menuitem} component={Link} key={key} to={`/shop/${key}`}>
              {title}
              {key === 'cart' ? <CardNumberBadge className={styles.shopPill} /> : null}
            </NavItem>
          ))}
        </PlainNav>
      </Sticky>
      {children}
    </React.Fragment>
  );
});

const Page = nest(PageTemplate, Menu);

export const CatalogItemsPage = nest(Page, withParams(Catalog.Items));
export const CatalogDetailsPage = nest(Page, withParams(Catalog.Details));
export const CatalogCartPage = nest(Page, withParams(CartPage));
export const CatalogOptionsPage = nest(Page, withParams(Options));
export const CatalogOrderHistoryPage = nest(Page, withParams(OrderHistoryPage));
export const CatalogOrderPaymentPage = nest(Page, withParams(PaymentPage));
